import create from 'zustand';
import ApiClient from '../networking/fetch';
import mapReport from './mapper';
import { Report } from './types';

export interface ReportState {
  allGrades?: string[];
  indiaMapData?: any;
  statesMapData?: { [key: string]: any };
  report?: { [key: string]: { [key: string]: Report } };
  selectedGrade?: string;
  currentDashboard?: Report;
  userData: any;
  fetchAllGrades: () => void;
  fetchDashboard: (base: string, grade: string) => void;
  fetchIndiaReport: (base: string, grade: string) => Promise<Report>;
  fetchIndiaMap: () => Promise<any>;
  fetchStateReport: (base: string, grade: string) => Promise<Report>;
  fetchStateMap: (state: string) => Promise<any>;
  updateSelectedGrade: (selectedGrade: string) => void;
  setUserData: (data: any) => void;
}

export const useStore = create<ReportState>((set) => ({
  userData: null,
  baseUrlData: null,
  setUserData: (data: any) => {
    set(() => ({
      userData: data,
    }));
  },
  fetchAllGrades: async () => {
    const response = await ApiClient.get(
      `${process.env.REACT_APP_BACKEND_URL}/reports/grades`
    );
    set({ allGrades: response.data, selectedGrade: response.data[0] });
  },
  fetchIndiaReport: async (base: string, grade: string) => {
    const response = await ApiClient.get(
      `${process.env.REACT_APP_BACKEND_URL}/reports/${base}`,
      { grade }
    );
    const data = mapReport(response.data);

    set((originalState) => {
      const selectedGrade = originalState.selectedGrade!;
      return {
        ...originalState,
        report: { [selectedGrade]: { india: data } },
      };
    });
    return data;
  },
  fetchDashboard: async (base: string, grade: string) => {
    const response = await ApiClient.get(
      `${process.env.REACT_APP_BACKEND_URL}/reports/${base}`,
      { grade }
    );
    const data = mapReport(response.data);
    set((originalState) => {
      return {
        ...originalState,
        currentDashboard: data,
      };
    });
  },
  fetchIndiaMap: async () => {
    const response = await ApiClient.get(
      'https://code.highcharts.com/mapdata/countries/in/custom/in-all-disputed.geo.json'
    );
    set({ indiaMapData: response.data });
    return response.data;
  },
  fetchStateReport: async (state: string, grade: string) => {
    const response = await ApiClient.get(
      `${process.env.REACT_APP_BACKEND_URL}/reports/india/${state}`,
      { grade }
    );
    const data = mapReport(response.data);
    set((originalState) => {
      const selectedGrade = originalState.selectedGrade!;
      return {
        ...originalState,
        report: {
          [selectedGrade]: {
            ...originalState.report![selectedGrade],
            [`india/${state}`]: data,
          },
        },
      };
    });
    return data;
  },
  fetchStateMap: async (state: string) => {
    const response = await ApiClient.get(
      `${process.env.REACT_APP_BACKEND_URL}/map-data/${state}`
    );
    set((originalState) => ({
      statesMapData: { ...originalState.statesMapData, [state]: response.data },
    }));
    return response.data;
  },
  updateSelectedGrade: async (selectedGrade: string) => {
    set(() => ({
      selectedGrade,
    }));
  },
}));
